import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { BackButton } from '../cta/cta'

interface fieldInterface {
    children: React.ReactNode
    step: number
    assignPostStep: (postStep: number) => void
    onBack?: () => void
    isFirstStep?: boolean
}

export const FormCard = (props: fieldInterface) => {
    const { children, step, assignPostStep, onBack, isFirstStep } = props
    const [cardVisibility, setCardVisibility] = useState('')

    useEffect(() => {
        if (step == -1) {
            setCardVisibility('hideFormCard')
        } else if (step >= 1) {
            setCardVisibility('hideFormCard')
            setTimeout(() => {
                setCardVisibility('')
                setTimeout(() => {
                    assignPostStep(step)
                    setCardVisibility('showFormCard')
                }, 400)
            }, 300)
        } else {
            setCardVisibility('showFormCard')
        }
    }, [step])

    // Find the first h3 element to insert the back button before it
    const childrenWithBackButton = React.Children.toArray(children).reduce((acc: React.ReactNode[], child, index) => {
        if (
            React.isValidElement(child) &&
            child.type === 'h3' &&
            onBack &&
            !isFirstStep &&
            !acc.some((c) => React.isValidElement(c) && c.type === BackButton)
        ) {
            // Insert back button before the h3 element
            acc.push(<BackButton key="back-button" onClick={onBack} />)
            acc.push(child)
        } else {
            acc.push(child)
        }
        return acc
    }, [])

    return (
        <div className={`${styles.formCard} ${styles[cardVisibility]}`}>
            {onBack && !isFirstStep ? childrenWithBackButton : children}
        </div>
    )
}
